import { render, staticRenderFns } from "./proFen.vue?vue&type=template&id=2aa3e814&scoped=true&"
import script from "./proFen.vue?vue&type=script&lang=js&"
export * from "./proFen.vue?vue&type=script&lang=js&"
import style0 from "./proFen.vue?vue&type=style&index=0&id=2aa3e814&scoped=true&lang=css&"
import style1 from "./proFen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3e814",
  null
  
)

export default component.exports